import { useEffect, useState } from 'react';

import fetch from 'unfetch';
import { BASE_URL } from '../../globals';

/**
 *
 * @param {*} externalId true or false if you are checking someone elses
 * @param {*} uuid the uuid of the user to check
 * @returns
 */
const getProfileImages = async (externalId, uuid) => {
	const url = `${BASE_URL}/api/profile/getProfileImages`;
	const res = await fetch(url, {
		method: 'POST',
		headers: {
			'content-type': 'application/json',
			authorization: `${localStorage.getItem('auth')}`,
		},
		body: JSON.stringify({
			externalId: externalId,
			uuid: uuid,
		}),
	});

	if (res.ok) {
		const data = await res.json();

		return { status: 'success', images: data[0]?.profile_images };
	} else {
		return { status: 'error' };
	}
};
export default getProfileImages;
